/**
 * Eigenbau: Der Zustand „Entwurf offen" aus der Vorlage, Abschnitt NOCH NICHT GEBAUT.
 *
 * Die Vorlage sieht diesen Bildschirm selbst vor: Titel in 46px Gewicht 200,
 * darunter eine volle Tintenlinie, ein Satz in 15px Gewicht 300 und die
 * Mono-Zeile „Entwurf offen". Er gehört zum Entwurf wie jeder andere Bereich.
 *
 * Wortlaut und Maße sind aus der Vorlage übernommen, nicht formuliert.
 *
 * Nicht `Leerzustand` aus dem Bestand: Der ist ein handlungsorientierter
 * Leerzustand mit Rabe, getönter Fläche und Knopf — hier gibt es nichts zu tun,
 * und die Vorlage zeigt an dieser Stelle keine Fläche, sondern Papier mit einer
 * Linie.
 */

import { Titel } from "@/components/entwurf/Titel";
import { Mikrolabel } from "@/components/entwurf/Mikrolabel";

export function EntwurfOffen({ titel }: { titel: string }) {
  return (
    <div className="max-w-[560px]">
      <Titel>{titel}</Titel>
      <div className="mt-11 border-t border-tinte pt-[22px]">
        <p className="text-[15px] font-light leading-[1.7] text-tinte3">
          Dieser Bereich ist im Entwurf noch nicht ausgearbeitet. Die Navigation
          führt ihn schon, damit die Struktur vollständig zu sehen ist.
        </p>
        <div className="mt-5">
          <Mikrolabel grad={12}>Entwurf offen</Mikrolabel>
        </div>
      </div>
    </div>
  );
}
